import React from 'react'
import { AccountContainer } from '../AccountContainer'
import { useContext } from './Context'
import { AddressEdit } from '../AddressEdit'
import { ProfileNameEdit } from '../ProfileNameEdit'
import { CustomerInlineInput } from '../CustomerInlineInput'
import { Alert, Icon } from '@ztechapps/webui.util'
import { WorldTimeZoneSelect } from '@ztechapps/webui.location'
import { Card, Stack } from 'react-bootstrap'
import { ChangePassword } from './ChangePassword'
import { CustomerCompanyNameInlineInput } from '../CustomerCompanyNameInlineInput'
import { PageTitle } from '../../../components/PageTitle'

export const Layout = () => {
  const { document } = useContext()

  return (
    <AccountContainer>
      <PageTitle
        title="Account Settings"
        description="Manage your account settings, including profile information, password, and notification preferences."
      />
      <Alert type={'warning'}>
        <small>Hover on the field name and click to start editing.</small>
      </Alert>

      <Card className=" mb-3">
        <Card.Header>
          <h4>Profile</h4>
        </Card.Header>
        <Card.Body>
          <Stack gap={4}>
            <ProfileNameEdit
              initialValues={document}
              label={'Name'}
              help={'The value that will be displayed on shipping labels when we ship items.'}
              displayContent={(e) => <div>{e}</div>}
            />
            <CustomerInlineInput
              initialValues={document}
              name="phone"
              label={'Phone'}
              emptyContent={<p className="text-info font-italic"> Click here to add phone number.</p>}
              displayContent={(e) => (
                <p>
                  <Icon name="phone" /> {e}
                </p>
              )}
            />
            <CustomerCompanyNameInlineInput customer={document} />

            <CustomerInlineInput
              initialValues={document}
              label={'TimeZone'}
              name="timeZone"
              editContent={({ setNewValue, ...rest }) => {
                const onChange = (e) => {
                  setNewValue(e?.value)
                }
                return <WorldTimeZoneSelect {...{ ...rest, onChange }} autoFocus />
              }}
              displayContent={(e) => (
                <p>
                  <Icon name="globe" /> {e}
                </p>
              )}
            />
            <ChangePassword />
          </Stack>
        </Card.Body>
      </Card>

      <div className="card mb-3">
        <div className="card-header">
          <h4>Shipping Address</h4>
        </div>
        <div className="card-body">
          <AddressEdit initialValues={document} help="This will the shipping address we will use when we ship items." />
        </div>
      </div>
    </AccountContainer>
  )
}
